export default __webpack_public_path__ + "static/media/SE80.92139d4a.png";